module.exports = __webpack_public_path__ + "static/media/txt.10533cd1.svg";